<section id="history" class="page-banner parallax-section">
    <div class="container-fluid text-center">
        <div class="row">
            <!-- <div class=" wow fadeInLeft col-md-1">
                <div class="d-flex" style="height: 100px;">
                    <div class="vr"></div>
                  </div>
            </div> -->
            <div class="wow fadeInUp offset-md-3 col-md-6 col-sm-7 " data-wow-delay="0.6s">
                <h1>PHOTO COLLECTION</h1>
                <ul>
                  <li>
                    <a routerlink="/" href="/">Home</a>
                  </li>
                  <li>Gallery</li>
                </ul>
            </div>
        </div> 
    </div>
</section>

<!-- Gallery -->
<!-- <div id="gallery-wrapper">
    <div class="container">
        <div class="row">
            <div class="col-md-4">
                <img src="assets/images/img/7107-image-1.jpg"  class="gallery-img img-fluid" alt="">
                <img src="assets/images/img/7107-image-2.jpg"  class="gallery-img img-fluid" alt="">
                <img src="assets/images/img/7107-image-3.jpg"  class="gallery-img img-fluid" alt="">
            </div>
            <div class="col-md-4">
                <img src="assets/images/img/7107-image-4.jpg"  class="gallery-img img-fluid" alt="">
                <img src="assets/images/img/7107-image-5.jpg"  class="gallery-img img-fluid" alt="">
                <img src="assets/images/img/7107-image-6.jpg"  class="gallery-img img-fluid" alt="">
            </div>
            <div class="col-md-4">
                <img src="assets/images/img/7107-image-7.jpg"  class="gallery-img img-fluid" alt="">
                <img src="assets/images/img/7107-image-8.jpg"  class="gallery-img img-fluid" alt="">
                <img src="assets/images/img/7107-image-9.jpg"  class="gallery-img img-fluid" alt="">
            </div>
        </div>
    </div>
</div> -->

<div id="gallery">
    <div class="container">
<!-- 
        <div class="title text-center mb-5">
            <h2 class="content-title">PHOTO COLLECTION</h2>
        </div> -->

        <div class="text-content wow fadeInUp" data-wow-delay=".6s">
            <h1>7107 Islands</h1>
            <h4 class="pb-4">Placement and Promotions</h4>
            <p>is a highly reputable employment agency with a proven track record of successful deployments and partnerships with global employers. They boast a vast network of esteemed companies and meticulously select skilled professionals to fulfill their workforce needs. Applicants benefit from personalized support, access to training programs, and seminars, enhancing their career prospects. The agency's experienced recruitment specialists ensure a seamless match between employers and candidates, prioritizing transparency and open communication throughout the hiring process. With a commitment to integrity and efficiency, 7107 Islands continues to be a leading global player, bridging the gap between talented professionals and exceptional employers worldwide.</p>
        </div>

        <div class="row row-cols-1 row-cols-md-3 g-4">
            <div class="col">
                <div class="card wow fadeInUp"  data-wow-delay=".6s">
                    <a href="#"><img src="/assets/images/training.jpg" alt=""></a>
                    <div class="intro">
                        <h5>TRAINING</h5>
                        <p>
                            7107 Islands Placement and Promotions, Inc offers training to applicants, enhancing their skills and professional development for better job prospects.
                        </p>
                    </div>
                </div>
            </div>
        
            <div class="col">
                <div class="card wow fadeInUp"  data-wow-delay=".7s">
                    <a href="#"><img src="/assets/images/meet-employers.jpg" alt=""></a>
                    <div class="intro">
                        <h5>MEET THE EMPLOYERS</h5>
                        <p>
                            7107 Islands Placement and Promotions, Inc connects with employers seeking manpower, providing them with skilled professionals to meet their workforce needs effectively.
                        </p>
                    </div>
                </div>
            </div>
        
            <div class="col">
                <div class="card wow fadeInUp"  data-wow-delay=".8s">
                    <a href="#"><img src="/assets/images/deployed.jpg" alt=""></a>
                    <div class="intro">
                        <h5>DEPLOYED APPLICANT</h5>
                        <p>
                            7107 Islands Placement and Promotions, Inc has successfully deployed skilled workers worldwide, fulfilling the workforce requirements of diverse employers across the globe.
                        </p>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>